/* eslint-disable max-len */
/**
 * @file 任务路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

export default [
  {
    label: '成长中心',
    key: 'growup-dashboard',
    href: '/agency/growup/dashboard',
    breathingLight: () => true,
    enableKey: 'is_grow_up_mlogin_enable',
    component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/growup/dashboard'), { fallback: <Loading /> }),
    basePage: true,
    hideTabNav: true,
    data: [{
      label: '激励中心',
      key: 'growup-incentive',
      href: '/agency/growup/incentive',
      component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/growup/incentive'), { fallback: <Loading /> }),
      basePage: true,
      hideTabNav: true,
      hide: true,
    }],
  },
];
